module.exports = __webpack_public_path__ + "static/media/move.22f48eec.wav";